import React from 'react';
import { Link } from "gatsby";

// Styles //
import "./greenCard.scss";

interface GreenCardProps {
    title: string;
    imageSrc: string;
    link: string;
    onClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
}

const removeAccents = (str) => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

const GreenCard = (props: GreenCardProps) => {
    const { title, imageSrc, link, onClick } = props;

    return (
        <div className="m-green-card" onClick={onClick}>
            <Link
                to={link}
                target="_blank"
                rel="noreferrer"
                data-topic-title={title}
                className={`gtm_${removeAccents(title).replace(/\s+/g, "").toLowerCase()}_${window.location.pathname.split('/')[2]}`}
            >
                <figure>
                    <img src={imageSrc} alt={title} />
                    <figcaption>{title}</figcaption>
                </figure>
            </Link>
        </div>
    )
}

export default GreenCard;